(function () {
    'use strict';

    var serviceId = 'externalAuthSvc';

    angular.module('app.security')
        .factory(serviceId, ['$location', '$q', 'appActivitySvc', 'notifierSvc', 'userSvc', 'restoreUrlService', '$state', '$translate', '$window', externalAuthSvc]);

    function externalAuthSvc($location, $q, appActivitySvc, notifierSvc, userSvc, restoreUrlService, $state, $translate, $window) {
        // var registrationInfo, associationInfo;

        var service = {
            handleAuthResponse: handleAuthResponse,
            // getRegistrationInfo: getRegistrationInfo,
            // getAssociationInfo: getAssociationInfo
        };

        return service;

        function handleAuthResponse() {
            appActivitySvc.busy("externalAuthSvc");
            var storedLang = $window.localStorage.getItem("Language") || 'tr';


            var locationPath = $location.path(),
                deferred = $q.defer();

            //login with Google or Facebook
            if (locationPath && locationPath.toLowerCase().indexOf("/externalauth") > -1) {
                var externalActionResult = parseResponse($location.hash());
                if (!externalActionResult || !externalActionResult.access_token) {
                    $translate('error_get_token').then(function (errorToken) {
                        notifierSvc.show({ message: errorToken, type: "error" });
                        appActivitySvc.idle("externalAuthSvc");
                        $state.go('signin', { langcode: storedLang });
                    });
                } else if (externalActionResult.error) {
                    $translate('confirm_error').then(function (confirmError) {
                        notifierSvc.show({ message: confirmError + externalActionResult.error, type: "error" });
                        appActivitySvc.idle("externalAuthSvc");
                        $state.go('signin', { langcode: storedLang });
                    });
                } else {
                    if (locationPath === "/externalauth/login") {
                        $window.localStorage.setItem("accessToken", externalActionResult.access_token);
                        $window.localStorage.setItem("refreshToken", externalActionResult.refresh_token);
                        $window.localStorage.setItem("accessTokenExpires", externalActionResult.access_token_expiration);
                        $window.localStorage.setItem("refreshTokenExpires", externalActionResult.refresh_token_expiration);
                    }
                    // else if (locationPath === "/externalauth/register") {
                    //     localStorage.setItem("accessToken", externalActionResult.access_token, false);
                    //     registrationInfo = externalActionResult;
                    // } else if (locationPath === "/externalauth/association") {
                    //     associationInfo = { externalAccessToken: externalActionResult.access_token };
                    // }
                    userSvc.getUserInfo()
                        .then(function (result) {
                            if (result.information) {
                                restoreUrlService.returnTo(true);
                            } else {
                                if (result.title || result.detail)
                                    notifierSvc.show({ message: result.detail ? result.detail : result.title, type: "error" });
                                $state.go("signin", { langcode: storedLang });
                            }
                        }, function (result) {
                            if (result.title || result.detail)
                                notifierSvc.show({ message: result.detail ? result.detail : result.title, type: "error" });
                            $state.go("signin", { langcode: storedLang });
                        })['finally'](
                            function () {
                                appActivitySvc.idle("externalAuthSvc");
                                deferred.resolve();
                            });
                }
            } else if (locationPath && locationPath.toLowerCase().indexOf('/confirmuser') > -1) {
                var confirmParams = {};
                window.localStorage.setItem("Language", storedLang);
                window.localStorage.setItem("NG_TRANSLATE_LANG_KEY", storedLang);
                if ($location.search().email && $location.search().token) {
                    confirmParams.email = $location.search().email;//.replaceAllString(' ', '+');
                    confirmParams.token = $location.search().token;//.replaceAllString(' ', '+');
                    userSvc.ConfirmEmail(confirmParams)
                        .then(
                            function () {
                                $state.go('signin', { status: 'activated', langcode: storedLang });
                            },
                            function (reject) {
                                if (reject.data.detail.indexOf('already') > -1)
                                    $state.go('signin', { status: 'activated', langcode: storedLang });
                                else
                                    $state.go('confirmEmail', { langcode: storedLang, email: confirmParams.email });
                            })['finally'](
                                function () {
                                    appActivitySvc.idle("externalAuthSvc");
                                    deferred.resolve();
                                });
                } else {
                    //redirect
                    appActivitySvc.idle("externalAuthSvc");
                    deferred.resolve();
                    $location.path('/' + storedLang + '/');
                }

            } else {
                appActivitySvc.idle("externalAuthSvc");
                deferred.reject();
            }
            return deferred.promise;
        }

        // function associateLogin() {
        //     var deferred = $.defer();
        //     userSvc.addExternalLogin(associationInfo)
        //         .then(
        //             function (result) {
        //                 //success
        //                 if (result && result.data && result.data.Succeeded) {
        //                     var associateLogin = $translate.instant('associate_login');
        //                     notifierSvc.show({ message: associateLogin, type: "info" });
        //                     restoreUrlService.returnTo();
        //                     $q.resolve(result);
        //                     //$state.go('profile.account', { langcode: storedLang });
        //                 } else {
        //                     if (result && result.data && result.data.Errors)
        //                         result.data.Errors.map(function (error) {
        //                             notifierSvc.show({ message: error.Message, type: "error" });
        //                         });
        //                     else
        //                         notifierSvc.show({ message: result.error, type: "error" });
        //                     $q.reject(result.error);
        //                 }
        //             },
        //             function (result) {
        //                 $translate('associate_login2').then(function (associateLogin2) {
        //                     notifierSvc.show({ message: associateLogin2, type: "error" });
        //                     deferred.reject(result);
        //                 });
        //             })['finally'](
        //                 function always() {
        //                     appActivitySvc.idle("externalAuthSvc");
        //                 });
        //     return deferred.promise;
        // }

        //function registerExternal(registerInfo) {
        //    ngDialog.open({
        //        template: '/app/security/register-loading.html',
        //        showClose: false,
        //        closeByEscape: false,
        //        data: {
        //            Message: 'Hesabınız Oluşturuluyor'
        //        }
        //    });
        //    userSvc.registerExternal(registerInfo).then(
        //        function () {
        //            ngDialog.close();
        //            ngDialog.open({
        //                template: '/app/security/register-loading.html',
        //                showClose: false,
        //                closeByEscape: false,
        //                data: {
        //                    Message: 'Giriş Yapılıyor'
        //                }
        //            });
        //            userSvc.signInExternal(registerInfo.LoginProvider).then(
        //                function (signInExternalResult) {
        //                    $window.location.href = signInExternalResult.data.Url;
        //                    ngDialog.close();
        //                },
        //                function (signInExternalResult) {
        //                    //error
        //                    ngDialog.close();
        //                    notifierSvc.show({ message: "Bir hata oluştu " + result.error, type: "error" });
        //                }
        //            );
        //        },
        //        function (registerExternalResult) {
        //            ngDialog.close();
        //            $location.path("/giris").hash('');
        //            registerExternalResult.errors.map(function (error) {
        //                notifierSvc.show({ message: error.Message, type: "error" });
        //            });
        //        });
        //}


        // function getRegistrationInfo() {
        //     return registrationInfo;
        // }

        // function getAssociationInfo() {
        //     return associationInfo;
        //}

        function parseResponse(response) {
            var result = {};

            var urlParts = response.split("&");

            urlParts.forEach(function (item) {
                var i = item.indexOf('=');
                var splitItem = [item.slice(0, i), item.slice(i + 1)];
                result[splitItem[0]] = decodeURIComponent(splitItem[1]);
            });

            return result;
        }
    }
})();